const formatCurrency = (currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(currency);

export default formatCurrency;